<!--
 * @Description:科室设置弹窗组件
 * @Date: 2023-12-20 18:26:55
-->
<template>
  <el-form-item label="科室要求：" required>
    <div style="display: flex;">
      <div>
        <el-radio
          :disabled="
            disableds ||
              (isImportedPeople == 1 && control == 0) ||
              (isImportedPeople == 1 && control == 1)
          "
          v-model="control"
          :label="0"
        >
          不限制
        </el-radio>
        <el-radio
          :disabled="disableds || (isImportedPeople == 1 && control == 0)"
          @click.native="seeCheck('view', $event, 1)"
          v-model="control"
          :label="1"
        >
          限制
        </el-radio>
      </div>
      <el-button
        :disabled="
          control == 0 ||
            this.controls == -1 ||
            (isImportedPeople == 1 && control == 0)
        "
        @click="seeCheck('')"
        style="margin-left: 50px;"
        type="text"
      >
        查看已选科室
      </el-button>
    </div>
  </el-form-item>
</template>

<script>
import createExtend from '@C/createExtend';
import seeDepartmentDialogs from './components/seeDepartmentDialog.vue';
import { projectV2 } from '@/api/ajax';
export default {
  props: {
    controls: {
      type: Number
    },
    projectId: { type: Number },
    isImportedPeople: {
      //是否已经导入过人员，1-是，0-否
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      disableds: this.controls == -1,
      control: this.controls !== -1 ? this.controls : 0,
      cancelFlag: false
    };
  },
  computed: {},
  watch: {
    control(v) {
      if (v == 0 && !this.cancelFlag) {
        try {
          let params = {
            isDeptLimit: v,
            projectId: this.projectId
          };
          projectV2
            .saveLimitDeptList(params)
            .then(() => {
              this.$message({
                type: 'success',
                message: '保存成功！'
              });
            })
            .catch(err => {
              if (this.isImportedPeople == 1) {
                this.control = this.controls;
              }
            });
        } catch (error) {
          console.log(error);
        }
      }
    }
  },
  methods: {
    seeCheck(val, e, num) {
      if (
        (val == 'view' && e.target.tagName === 'INPUT') ||
        this.controls == -1 ||
        this.disableds ||
        (this.isImportedPeople == 1 && this.control == 0)
      )
        return;

      let seeDepartmentDialogsDom = createExtend(seeDepartmentDialogs, {
        titles: val == 'view' ? '科室设置' : '科室要求',
        dialogVisibles: true,
        control: num == 1 ? num : this.control,
        projectId: this.projectId,
        getAjax: projectV2.queryLimitDeptList,
        saveAjax: projectV2.saveLimitDeptList,
        footer: val == 'view',
        disableds: val !== 'view',
        oldControls: this.controls,
        isImportedPeople: this.isImportedPeople ? this.isImportedPeople : 0
      });
      seeDepartmentDialogsDom.$on('cancel', val => {
        this.control = val;
        this.cancelFlag = true;
      });
    }
  },
  created() {},
  mounted() {
    console.log('controls', this.controls);
  }
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
</style>
